/**
 * Make a proxy that will return a value corresponding to a bucket.
 *
 * Unlike range-object, this one is space efficient and works with floats.
 *
 * @param tuples - should be pre-sorted.
 */
export default function rangeBucket<TVal>(
  tuples: [number, TVal][],
): Record<number, TVal> {
  return new Proxy(
    {},
    {
      get(_, value) {
        for (let i = tuples.length - 1; i >= 0; i--) {
          const [k, v] = tuples[i];
          if (Number(value) >= k) {
            return v;
          }
        }
      },
    },
  );
}
